import { getLabel } from '@components/modules/ProductGrid/Filter/filtering'
import { CustomProductGridTile } from '@features/products/api/get-custom-product-grid-tiles'
import { mapEdgesToItems } from '@utils/map'
import { useMemo } from 'react'

type Collection = {
  value: string
  label: string
  count: number
}

export const useFindDesigners: (
  products: Partial<CustomProductGridTile>[],
  countProductsOnly?: boolean,
) => {
  designers: Collection[]
} = (products, countProductsOnly) => {
  const designers = useMemo(
    () =>
      [
        ...new Set(
          products
            .map((product) =>
              product.tags
                ?.filter((tag) => tag.startsWith('designer_'))
                .map((tag) =>
                  JSON.stringify({
                    name: tag,
                    label:
                      product.name.includes(tag.split('_')[1]) &&
                      product.name.includes('-')
                        ? getLabel(tag)
                        : getLabel(tag).replace(/-/gm, ' '),
                  }),
                ),
            )
            .flat(),
        ),
      ].map((unparsedTag) => {
        if (!unparsedTag) return
        const parsedTag = JSON.parse(unparsedTag)
        return {
          value: parsedTag.name,
          label: parsedTag.label,
          count: countProductsOnly
            ? products?.reduce(
                (count, product) =>
                  product.tags.find((tag) => tag === parsedTag.name)
                    ? count + 1
                    : count,
                0,
              )
            : products?.reduce(
                (count, product) =>
                  product.tags.find((tag) => tag === parsedTag.name)
                    ? count +
                      (false ? 0 : mapEdgesToItems(product.variants)?.length)
                    : count,
                0,
              ),
        }
      }),
    [products, countProductsOnly],
  )

  return { designers }
}
